import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class QuestionScores extends BaseModel {
  constructor() {
    super(collection(db, 'question_scores'))
  }
}
